export const ProjectReducer = (state, action) => {
	switch(action.type) {
		case 'GET_ALL_PROJECTS' :
			return action.projects;
		default :
			return state;
	}
}